export const urlRegExp = new RegExp(
  /* eslint-disable-next-line no-useless-escape */
  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)|localhost/,
  'gi'
)

export const isValidMediaUrl = url => {
  return isYouTube(url) || isVimeo(url) || isSlideShare(url)
}

export const isBase64Image = url => {
  return url && url.slice(0, 11) === 'data:image/'
}

export const getMediaUrl = url => {
  let mediaUrl
  if (isYouTube(url)) {
    mediaUrl = getYouTubeUrl(url)
  } else if (isVimeo(url)) {
    mediaUrl = getVimeoUrl(url)
  } else if (isSlideShare(url)) {
    mediaUrl = getSlideShareUrl(url)
  }
  return mediaUrl
}

const isYouTube = url => {
  // https://www.youtube.com/watch?v=SLaob4DlMCc
  // https://youtu.be/SLaob4DlMCc
  return (
    url &&
    ((url.indexOf('youtube') !== -1 && url.indexOf('watch?') !== -1) ||
      url.indexOf('youtu.be/') !== -1)
  )
}
const isVimeo = url => {
  return url && url.indexOf('vimeo.com/') !== -1
}

const isSlideShare = url => {
  return (
    url && url.indexOf('<iframe') !== -1 && url.indexOf('slideshare.net') !== -1
  )
}

const getYouTubeUrl = url => {
  let videoId
  const params = new URLSearchParams(url.split('?')[1])
  if (url.indexOf('youtube') !== -1 && url.indexOf('watch?') !== -1) {
    videoId = params.get('v')
  }

  if (url.indexOf('youtu.be/') !== -1) {
    videoId = url
      .split('/')
      .pop()
      .split('?')
      .shift()
  }
  const start = params.get('t') ? `?start=${params.get('t')}` : ''
  if (videoId) return `https://www.youtube.com/embed/${videoId}${start}`
}

const getVimeoUrl = url => {
  const videoId = url.split('/').pop()
  if (videoId) {
    return `https://player.vimeo.com/video/${videoId}`
  }
}

const getSlideShareUrl = url => {
  const keyMarker = '/slideshow/embed_code/key/'
  if (url.indexOf('iframe') !== -1 && url.indexOf(keyMarker) > -1) {
    const slideKey = url
      .split(keyMarker)
      .pop()
      .split('"')
      .shift()
    return `https://www.slideshare.net${keyMarker}${slideKey}`
  }
}
